import type { ReactNode } from 'react';

import Typography from '@classify/react-core-components/Typography';
import { styled } from '@classify/react-core-components/styles';
import { ListItem } from '@mui/material';

interface Props {
  children: ReactNode;
}
const Item = styled(Typography)(({ theme: { palette, spacing } }) => ({
  paddingTop: spacing(2),
  color: palette.text.onMainMinor,
}));

const OverTitleListItem = ({ children }: Props) => (
  <ListItem>
    <Item variant="overline">{children}</Item>
  </ListItem>
);

export default OverTitleListItem;
